import { render, staticRenderFns } from "./zap.vue?vue&type=template&id=7ffdd920&"
import script from "./zap.vue?vue&type=script&lang=js&"
export * from "./zap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QCard,QCardSection,QInput,QBtn,QCardActions} from 'quasar'
component.options.components = Object.assign({QPage,QCard,QCardSection,QInput,QBtn,QCardActions}, component.options.components || {})
